import React from 'react';
import './styles/SecurePortal.css'; // You can extract only the header-related styles

const PortalHeader = () => {
  return (
    <header className="portal-header">
      <div className="logo-container">
        <i className="fas fa-file-shield logo-icon"></i>
        <h1>Lüt <span>Docs</span></h1>
      </div>
      <p className="tagline">Secure document collection portal for HubSpot</p>
    </header>
  );
};

export default PortalHeader;
